import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="expenses--document"
// This controller handles file uploads and delegates to appropriate preview controllers
export default class extends Controller {
  handleFileUpload(event) {
    const file = event.target.files[0]
    if (file) {
      // Create object URL for preview
      const objectUrl = URL.createObjectURL(file)

      // Delegate to preview controllers - they will decide if they can handle the file
      this.notifyPreviewControllers(file, objectUrl)

      // Connect to the main form file input
      const mainFileInput = document.getElementById("main-expense-file-input")
      if (mainFileInput) {
        // Create a new FileList with the selected file
        const dataTransfer = new DataTransfer()
        dataTransfer.items.add(file)
        mainFileInput.files = dataTransfer.files

        // Trigger change event on main input
        mainFileInput.dispatchEvent(new Event("change", { bubbles: true }))
      }
    }
  }

  // LUC-415 — replacing the document on a SAVED expense. The input lives in its
  // own little form that posts to #retry_extraction, so picking a file is the
  // whole interaction: swap the document and re-run the extraction in one go.
  // The main form is deliberately not involved — its validations are what makes
  // the "bad PDF" case unrecoverable in the first place.
  handleReplaceUpload(event) {
    const input = event.target
    const file = input.files?.[0]
    if (!file) return

    // Optimistic preview, so the panel shows the new document while the request
    // is in flight; the Turbo Stream response redraws the tab from the server.
    this.notifyPreviewControllers(file, URL.createObjectURL(file))

    const form = input.form
    if (!form) return

    // Disable only once Turbo has built the request body (turbo:submit-start
    // fires after the FormData is read) — a disabled input is not serialised,
    // so flipping it before submitting would post no file at all.
    form.addEventListener(
      "turbo:submit-start",
      () => {
        input.disabled = true
      },
      { once: true }
    )
    form.addEventListener(
      "turbo:submit-end",
      () => {
        input.disabled = false
        // Let the same file be picked again after a rejected upload.
        input.value = ""
      },
      { once: true }
    )

    form.requestSubmit()
  }

  extractAgain(event) {
    event.preventDefault()
    // TODO: Implement extraction functionality
  }

  // Notify all preview controllers about the file - they decide if they can handle it
  // TODO; check if still needed
  notifyPreviewControllers(file, objectUrl) {
    const container = this.element.querySelector('[data-controller*="expenses--image-preview"]')

    if (container) {
      const imageController = this.application.getControllerForElementAndIdentifier(
        container,
        "expenses--image-preview"
      )
      const pdfController = this.application.getControllerForElementAndIdentifier(container, "expenses--pdf-preview")

      // Let each controller handle the file if it can
      if (imageController && typeof imageController.handleFile === "function") {
        imageController.handleFile(file, objectUrl)
      }
      if (pdfController && typeof pdfController.handleFile === "function") {
        pdfController.handleFile(file, objectUrl)
      }
    }
  }
}
